module.exports = __webpack_public_path__ + "img/IMG_6736.3493a3dd.jpeg";